import { KeyboardEventHandler } from 'react';

export const preventFormSubmit: KeyboardEventHandler<HTMLFormElement> = (e): void => {
  if (e.key === 'Enter' && (e.target as AnyValue).nodeName !== 'TEXTAREA') {
    e.preventDefault();
  }
};
